<template>
	<div class="course-detail">
		<div class="buttons flex flex-row justify-around md:justify-between">
			<button type="button" class="twn-button text-xs" @click="goBack">
				Retour
			</button>
			<div>
				<button
					type="button"
					class="twn-button text-xs danger mr-4"
					@click="showDeleteModal"
					v-if="!itemID"
				>
					Supprimer le parcours
				</button>
				<button
					class="twn-button text-xs"
					@click="save"
				>
					Enregistrer
				</button>
			</div>
		</div>

		<div class="my-10" v-if="!loading">
			<div class="flex">
				<div v-if="!itemID" class="uppercase font-principal-bold text-sm">
					Création d'un nouveau parcours
				</div>
				<div v-else class="uppercase font-principal-bold text-sm">
					Éditer le parcours
				</div>
			</div>

			<div class="mt-8">
				<div class="flex">
					<div class="flex-1 mr-8">
						<label>Identifiant</label>
						<b-form-input v-model="fields.identifier" type="text" />
					</div>
					
					<div class="flex-1">
						<label>Nom du parcours</label>
						<b-form-input v-model="fields.title" type="text" />
					</div>

					<!-- todo: type dans la liste ? définit à création uniquement pas de conversion ! <div class="flex-1 mr-8">
						<label class="mr-8">Type de parcours</label>
						<v-select
							class="flex-1 mr-auto"
							label="name"
							:options="types"
							placeholder="Type du parcours"
							v-model="fields.type"
							@input="changeType"
							:reduce="type => type.id"
							:selectable="type => type.slug != 'custom_course'"
						/>
					</div> -->
				</div>

				<div class="flex mt-4">
					<div class="flex-1 mr-8">
						<label for="narrator-intro">Narrateur - Introduction</label>
						<v-select
						id="narrator-intro"
						placeholder="Rechercher une narration..."
						:options="narrativeList"
						:getOptionLabel="getOptionLabel"
						:reduce="narrative => narrative.id"
						@input="setMetaValue('narrator_intro', $event)"
						:value="getMetaValue('narrator_intro')" />
					</div>
					
					<div class="flex-1">
						<label for="narrator-outro">Narrateur - Épilogue</label>
						<v-select
						id="narrator-outro"
						placeholder="Rechercher une narration..."
						:options="narrativeList"
						:reduce="narrative => narrative.id"
						:getOptionLabel="getOptionLabel"
						@input="setMetaValue('narrator_outro', $event)"
						:value="getMetaValue('narrator_outro')" />
					</div>
				</div>

				<div class="mt-8 module-container" v-if="courseType">
					<!-- module choice -->
					<div v-if="courseType != 'bloc_course' && fields.modules[activeModule]">
						<div class="module-selector justify-around rounded border border-gray-light">
							<div
								v-for="(module, i) in fields.modules"
								:key="i"
								class="module-select-container"
								:class="{'active': activeModule == i}"
								@click="activeModule = i"
							>
								<p class="truncate">
									{{ [module.identifier, module.title].filter(str => (str || false)).join(' - ') || 'Module ' + (module.order + 1) }}
								</p>
							</div>
							<button v-if="!fields.modules || fields.modules.length < 4" class="py-2 px-6 font-principal-bold text-xl border-l border-l-gray-light" @click="addModule">+</button>
						</div>

						<button class="twn-button danger py-2 my-4 ml-auto block" @click="showDeleteModuleModal">Supprimer</button>

						<component
						:is="moduleComponent"
						:module="fields.modules[activeModule]"
						@update-module="updateModuleData($event)" />
					</div>

					<component
					:is="sequencesComponent"
					:module="fields.modules[activeModule]"
					@update-module="updateModuleData($event)" />
				</div>
			</div>
		</div>

		<!-- Modals -->
		<b-modal
			ref="delete-modal-course"
			class="bootstrap"
			centered
			hide-footer
			id="delete-modal-course"
			hide-header
		>
			<div class="d-block text-center my-6 uppercase font-semibold">
				<h3>Confirmer la suppression {{isDeleteModule ? "du " + (courseType == 'complete_course' ? 'niveau' : 'module') : ""}}</h3>
			</div>
			<div class="flex flex-row justify-evenly items-center">
				<button type="button" class="mt-4 twn-button" @click="hideModal" >
					Retour
				</button>
				<button type="button" class="mt-4 twn-button danger" @click="confirmDelete">Supprimer</button>
			</div>
		</b-modal>
	</div>
</template>

<script>
import { mapGetters, mapState } from "vuex"
import { debounce } from "@/utils/utils"
import {SEARCH_SCENARIO} from '@/graphql/course'

import MissionModuleForm from "@/components/common/course/MissionModuleForm"
import MissionSequences from "@/components/common/course/MissionSequences"

import InvestigationModuleForm from "@/components/common/course/InvestigationModuleForm"
import InvestigationSequences from "@/components/common/course/InvestigationSequences"

export default {
    props: {
        itemID: {
            type: String,
            required: false
        },
        previousPage: {
            type: Number,
            required: false
        }
    },
	data(){
		return{
			loading: true,
			isDeleteModule: false,
			nameTaken: false,
			fields: {
				id: null,
				identifier: '',
				title: '',
				type: null,
				metas: [],
				modules: this.defaultModule()
			},
			activeModule: 0,
			scenarioOptions: [],
			revisionOptions: [],
		}
	},

	computed: {
		...mapGetters("EditItem", ["getCurrentID"]),
		...mapState("Course", ["types"]),
		...mapState({
			scenarioList: state => state.Scenarios.list,
			mediaList: state => state.Media.list,
			narrativeList: state => state.Narratives.list,
			pictureList: state => state.Media.list.filter((medium) => medium.type.slug == 'image'),
			metaTypes: state => {
				return state.Utils.metaTypeList.reduce((dict, meta) => {
					dict[meta.slug] = meta
					return dict
				}, {})
			}
		}),
		...mapGetters("Course", ["typeListFormat"]),
		courseType() {
			if (!this.typeListFormat || !this.fields.type || !this.typeListFormat[this.fields.type])
				return null

			return this.typeListFormat[this.fields.type].slug
		},
		moduleComponent() {
			switch (this.courseType) {
				case 'mission':
					return MissionModuleForm

				case 'investigation':
					return InvestigationModuleForm
			}

			return null
		},
		sequencesComponent() {
			switch (this.courseType) {
				case 'mission':
					return MissionSequences

				case 'investigation':
					return InvestigationSequences
			}

			return null
		}
	},

	async mounted() {
		this.loading = true
		await this.$store.dispatch("Course/GetCourseTypes")
		await this.$store.dispatch("Scenarios/getList")
		await this.$store.dispatch("Media/getList")
		await this.$store.dispatch("Narratives/getList")
		await this.$store.dispatch("Games/getJaugeList")
		await this.getScenario("", false)
		await this.getScenario("", true)
		this.loading = false
	},

	watch: {
		itemID: {
			handler(itemID) {
				if (itemID){
					this.mapFields()
				}
			},
			immediate: true
		}
	},

	methods: {
		getOptionLabel(option) {
			if (!option)
				return '~ Élément supprimé ~'

			return [option.identifier, option.name, option.title].filter(str => str || false).join(' - ') || '~ Élément sans titre ou supprimé ~'
		},
		getMeta(slug) {
			for (var i = 0; i < this.fields.metas.length; i++) {
				if (this.fields.metas[i].meta_type_id == this.metaTypes[slug].id) {
					return { meta: this.fields.metas[i], index: i }
				}
			}

			return { meta: null, index: -1 }
		},
		getMetaValue(slug) {
			const { meta } = this.getMeta(slug)

			return ((meta && meta.value) || null)
		},
		setMetaValue(slug, value) {
			let { meta, index } = this.getMeta(slug)

			if (meta) {
				if (value) {
					meta.value = value
				} else {
					this.fields.metas.splice(index, 1)
				}
			} else if (value) {
				this.fields.metas.push({
					value,
					meta_type_id: this.metaTypes[slug].id
				})
			}
		},
		updateModuleData(moduleData) {
			const dataKeys = Object.keys(moduleData)

			for (var i = 0; i < dataKeys.length; i++) {
				this.fields.modules[this.activeModule][dataKeys[i]] = moduleData[dataKeys[i]]
			}
		},
		getSequenceMeta(index, slug) {
			const sequence = this.fields.modules[this.activeModule].sequences[index]

			return sequence.metas.find(meta => meta.meta_type_id == this.metaTypes[slug].id)
		},
		getSequenceMetaValue(index, slug) {
			const meta = this.getSequenceMeta(index, slug)

			return ((meta && meta.value) || null)
		},
		setSequenceMetaValue(index, slug, value) {
			let meta = this.getSequenceMeta(index, slug)

			if (meta) {
				meta.value = value
			} else {
				this.fields.modules[this.activeModule].sequences[index].metas.push({
					value,
					meta_type_id: this.metaTypes[slug].id
				})
			}
		},
		confirmDelete(){
			if (this.isDeleteModule){
				this.deleteModule()
			} else {
				this.$store.dispatch("Course/Delete", this.itemID)
				this.goBack()
			}

			this.hideModal()
		},
		fetchScenariosByName(name, loading) {
			loading(true)
			this.searchScenario(loading, name, false, this)
		},

		fetchRevisionByName(name, loading) {
			loading(true)
			this.searchScenario(loading, name, true, this)
		},

		searchScenario: debounce((loading, name, isRevision, vm) => {
			vm.getScenario(name, isRevision).then(() => loading(false));
		}, 350),

		getScenario(name, isRevision){
			return new Promise((resolve) => {
				this.$apollo.query({
					query: SEARCH_SCENARIO,
					variables: {
						identifier: `%${name}%`,
						slugs: isRevision ? ['revision'] : ['scenario', 'edl'] //todo: not revision instead of only scenario
					}
				}).then((res) => {
					if (res.data){
						if (isRevision){
							this.revisionOptions = res.data.scenario
							resolve()
						}else{
							this.scenarioOptions = res.data.scenario
							resolve()
						}
					}
				})
			})
		},

		goBack() {
			// this.$router.push({name:'course-list', params: {
			// 	previousPage: this.previousPage
			// }})
		},

		async mapFields(){
			const fields = await this.$store.dispatch("Course/GetCourse", this.itemID)
			fields.modules = fields.modules.map(module => {
				let moduleret = module

				moduleret.sequences = module.sequences.map(sequence => {
					let sequenceret = sequence;

					sequenceret.media = sequence.media.map(assoc => {
						return {
							id: assoc.media.id,
							identifier: assoc.media.identifier,
							order: assoc.order,
							type: assoc.media.type,
						}
					}).sort((a, b) => {
						return (a.order > b.order ? 1 : (a.order < b.order ? -1 : 0))
					})

					return sequenceret
				})
				return moduleret;
			})

			this.fields = fields

			this.changeType(this.fields.type);
		},

		showDeleteModal() {
			this.$refs["delete-modal-course"].show()
		},
		showDeleteModuleModal(){
			this.isDeleteModule = true
			this.$refs["delete-modal-course"].show()
		},
		removeSequence(index) {
			//remove
			if (this.fields.modules[this.activeModule].sequences.length > 1){
				this.fields.modules[this.activeModule].sequences.splice(index, 1)
			}

			this.fields.modules[this.activeModule].sequences.forEach((sequence, i) => {
				if (i >= index){
					//
					sequence.order--
				}
			})
		},
		changeType(typeID) {
			if (this.typeListFormat[typeID] && this.typeListFormat[typeID].slug == "bloc_course") {
				this.activeModule = 0
			}
		},
		addModule(){
			this.fields.modules.push(this.defaultModule(this.fields.modules.length))
			this.activeModule = this.fields.modules.length - 1
		},
		defaultModule(order = 0){
			return {
				id: null,
				identifier: "",
				title: "",
				scenarios: [],
				metas: [],
				media: [],
				order,
				sequences: [
					{
						identifier: "",
						title: "",
						order: 0,
						scenarios: [],
						revisions: [],
						media: [],
						metas: []
					}
				]
			}
		},
		deleteModule(){
			if (this.fields.modules.length > 1){
				this.fields.modules.splice(this.activeModule, 1)
				this.fields.modules.forEach((module, i) => {
					if (i >= this.activeModule){
						module.order--
					}
				})
				if (this.activeModule - 1 >= 0){
					this.activeModule -= 1
				}

				this.$forceUpdate();
			}
		},
		async save(){
			if (this.fields.identifier && this.fields.identifier !== "") {
				const response = await this.$store.dispatch('Course/saveCourse', this.fields)
				if (response && response.error){
					this.$bvToast.toast('Une erreur est survenue, l\'un des champs requis doit être manquant', { title: `Erreur` })
					return;
				}

				if (response == false){
					this.nameTaken = true
					this.$bvToast.toast('Le nom est déjà pris !', { title: `Erreur` })
					return;
				}

				if (!this.itemID && response.id){
					this.fields.id = response.id
					this.$router.push({
						name: 'course-edit',
						params: {
							itemID: response.id,
							previousPage: this.previousPage
						}
					})
				}

				this.$bvToast.toast('Vos modifications ont bien été enregistrés !', { title: `Succès !` })
			}
		},
		hideModal(){
			this.$bvModal.hide('delete-modal-course')
			this.isDeleteModule = false
		}
	}
}
</script>
<style lang="scss" scoped>
.course-detail {
	.shadowed {
		box-shadow: $cardShadow;
	}
	.module-container{
		// border: 1px solid #DC9799;
		// box-shadow: $cardShadow;
		// padding: 1rem;
	}
	.module-selector{
		@apply flex flex-no-wrap flex-row mb-8;
	}
	.module-select-container{
		@apply font-principal-medium flex-1 flex min-w-0 justify-center items-center cursor-pointer px-4 py-2;

		&.active{
			@apply bg-principal-selected text-white;
		}
	}
	// .content{
	//     border-top: 1px solid $textMainColor;
	//     border-bottom: 1px solid $textMainColor;
	// }
}
</style>
